module.exports = __webpack_public_path__ + "static/media/AirTractor-AsaEsquerda.2f5f9bd8.png";